import store from 'store'

export function round (quantity) {
  const formatter = new Intl.NumberFormat(store.state.i18n.locale)

  return formatter.format(quantity)
}

export function percentage (quantity) {
  const formatter = new Intl.NumberFormat(store.state.i18n.locale)
  const result = formatter.format(quantity / 100)

  return `${result} %`
}
